module.exports = __webpack_public_path__ + "img/precise_localization.cb091089.png";